<template>
  <div id="evaluations-panel" class="pt-5 pb-5 is-max-desktop">
    <EvaluationBreadcrumb :links="links" />
    <div v-if="!isLoadingEvaluation">
      <EvaluationHeader :evaluation="evaluation" />
      <div id="evaluations-details" class="box">
        <b-button
          v-if="isUserAllowed"
          tag="router-link"
          :to="{ name: 'evaluation-process', params: { evaluationId: $route.params.evaluationId }}"
          type="is-secondary"
          label="Nueva evaluación"
          class="mb-2 is-pulled-right" />
        <div class="is-clearfix" />
        <EvaluationTable :id-number="evaluation.idNumber" />
      </div>
    </div>
    <Spinner v-if="isLoadingEvaluation" />
  </div>
</template>

<script>
import { EvaluationsClient } from '@/application/services/api-clients/evaluations-client';
import { evaluationsBackend } from '@/application/api';
import { authenticationService } from '@/application/services/api-clients/login-service';
import Spinner from '@/ui/components/Spinner.vue';
import EvaluationHeader from '@/ui/components/internal/evaluations/EvaluationHeader.vue';
import EvaluationTable from '@/ui/components/internal/evaluations/EvaluationTable.vue';
import EvaluationBreadcrumb from '@/ui/components/internal/evaluations/EvaluationBreadcrumb.vue';

export default {
  name: 'Evaluations',
  components: {
    EvaluationBreadcrumb,
    EvaluationTable,
    EvaluationHeader,
    Spinner
  },
  data() {
    return {
      evaluation: {},
      isLoadingEvaluation: true,
      links: []
    };
  },
  async mounted() {
    await this.fetchEvaluation();
  },
  methods: {
    isUserAllowed() {
      return this.$store.state.currentUser.user.allowedUserFeatures?.includes('element.evaluation.tab.comprobar') || this.$store.state.currentUser.user.rol === 'ADMIN';
    },
    setlinksForBreadcrumb() {
      this.links.push({
        to: { name: 'evaluation-detail', params: { evaluationId: this.$route.params.evaluationId } },
        active: true,
        label: `${this.evaluation.name} ${this.evaluation.lastName}`
      });
    },
    async fetchEvaluation() {
      try {
        this.evaluation = await this.getEvaluationData();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error al obtener la evaluación:', error);
      } finally {
        this.isLoadingEvaluation = false;
        this.setlinksForBreadcrumb();
      }
    },

    async getEvaluationData() {
      try {
        const evaluationClient = new EvaluationsClient(evaluationsBackend, authenticationService);
        return await evaluationClient.getEvaluationById(this.$route.params.evaluationId);
      } catch (_error) {
        throw new Error('No se pudo obtener la evaluación$ {_error.message}');
      }
    }
  }
};
</script>
<style scoped>
h2 {
  color: var(--color-nickel);
}
.box {
  border-radius: 10px;
}
a.is-secondary{
  background-color: var(--secondary);
  color: #FFF !important;
  font-weight: 600;
  border-color: transparent;
}
</style>
